import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoyaltyService } from '../../../services/loyalty.service';
import { PanelModule } from '../../../modules/panel.module';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'brt-reward-save',
  standalone: true,
  imports: [PanelModule, InputNumberModule, CheckboxModule, InputSwitchModule],
  templateUrl: './reward-save.component.html',
  styleUrl: './reward-save.component.css'
})
export class RewardSaveComponent {
  constructor(private loyaltyService: LoyaltyService) { }

  @Input() reward: any;
  @Output() onSave = new EventEmitter<void>();
  ngOnInit() {
    if (!this.reward) this.reward = { Items: [{}] };
  }

  async save() {
    if (!this.reward.Items) this.reward.Items = [];
    await this.loyaltyService.saveReward(this.reward);
    this.onSave.emit();
  }
}
